// implement your own methods in here, if your data is coming from A rest API

import CurrentSession from './CurrentSession'
import User from './User'
import Laboratory from './Laboratory'
import Product from './Product'
import Distributor from './Distributor'
import Invoice from './Invoice'
import Transit from './Transit'
import Dashboard from './Dashboard'
import Menu from './Menu'
import Role from './Role'
import OrganoAnuente from './OrganoAnuente'
import Shipment from './Shipment'
import Transporter from './Transporter'
import BitacoraTemplate from './BitacoraTemplate'
import PendingReason from './PendingReason'
import Report from './Report'
import TransportDocument from './TransportDocument'
import Holiday from './Holiday'
import AccountStatement from './AccountStatement'

export default {
  CurrentSession,
  Laboratory,
  User,
  Product,
  Distributor,
  Invoice,
  Transit,
  Dashboard,
  Menu,
  Role,
  OrganoAnuente,
  Shipment,
  Transporter,
  BitacoraTemplate,
  PendingReason,
  Report,
  TransportDocument,
  Holiday,
  AccountStatement,
}
